import { Field } from '@klarna/bubble-ui';
import { validators } from '@/flow/validation';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';
import { CY_ADDRESS_FORM_COMPONENT_IDS, tPrefix } from '../constants';

const { INPUT_CITY } = CY_ADDRESS_FORM_COMPONENT_IDS;

export const cityField = (t, defaultField = {}, { isMobile = false }) => ({
  ...defaultField,
  component: Field,
  size: isMobile ? 1 : 0.5,
  type: 'text',
  label: t(`${tPrefix}.city.label`),
  validators: [
    {
      callback: validators.common.isRequired,
      errorMessage: t(`${tPrefix}.city.error`),
    },
  ],
  extraProps: {
    ...defaultField.extraProps,
    ...generateCyElemId(INPUT_CITY, window),
    isUnderlined: true,
  },
});
